import * as React from 'react';
import { observer } from 'mobx-react';

import FadeScroll from 'shared/newComponents/FadeScroll';
import { CommonDirection } from 'shared/entities/common/client';
import { WidgetChannelCreationStore } from 'stores/channelCreationStores';
import { useChannelsModalStore } from 'stores/ChannelsModalStore';

import WidgetCreate from './WidgetCreate';
import WidgetInstall from './WidgetInstall';

import './Widget.modules.scss';

type WidgetProps = {
  channelCreationStore: WidgetChannelCreationStore;
};

const Widget: React.FC<WidgetProps> = ({ channelCreationStore }) => {
  const { store } = useChannelsModalStore();
  const channel = channelCreationStore.channel;

  const handleCheckInstall = React.useCallback(async () => {
    if (!channel) {
      return;
    }

    const isSuccess = await channel.checkInstall();

    if (isSuccess && !store.withSections) {
      store.handleChannelCreate(channel.id);
    }
  }, [channel, store]);

  return (
    <FadeScroll
      boxShadowCompensation={CommonDirection.left}
      styleName="widget__scroll-wrapper"
    >
      {!channel?.id ? (
        <WidgetCreate store={channelCreationStore} />
      ) : (
        <WidgetInstall
          store={channel}
          onCheckInstall={handleCheckInstall}
          isLoading={channel.isInstallCheckBlocked}
        />
      )}
    </FadeScroll>
  );
};

export default observer(Widget);
